import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { NavLink } from "react-router-dom";

const MsbBenefits = () => {
  const sectionRef = useRef(null);

  // Check if the section is in view and animate only once
  const isInView = useInView(sectionRef, { once: true });

  // Animation variants for each benefit block
  const itemVariants = {
    hidden: { opacity: 0, y: 50 }, // Start hidden and below
    visible: {
      opacity: 1,
      y: 0, // Move to original position
      transition: {
        duration: 0.6,
        ease: "easeOut", // Smooth transition
      },
    },
  };

  // Animation container for staggered children
  const containerVariants = {
    visible: {
      transition: {
        staggerChildren: 0.2, // Delay between each child animation
      },
    },
  };

  return (
    <div>
      <section
        className="funfact_section section_space"
        style={{ overflow: "hidden" }}
      >
        <div className="container">
          <div className="heading_block style_2">
            <div className="row align-items-lg-end justify-content-lg-between">
              <motion.div
                ref={sectionRef}
                initial="hidden"
                animate={isInView ? "visible" : "hidden"}
                variants={{
                  hidden: { opacity: 0 },
                  visible: { opacity: 1, transition: { duration: 1 } },
                }}
                className="heading_block style_2 text-center"
              >
                <div className="badge style_2 text-uppercase">
                  <i className="fa-solid fa-circle text-primary"></i>Our
                  Benefits
                  <i className="fa-solid fa-circle text-primary"></i>
                </div>
                <h2 className="heading_text mb-0">
                  Benefits of Joining MSB Association
                </h2>
              </motion.div>
            </div>
          </div>
          <motion.div
            className="row justify-content-center section_decoration"
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            variants={containerVariants}
          >
            {/* Benefit Items */}
            {[
              {
                text: "Regulatory Compliance Support",
                to: "/overview#RegulatoryComplianceSupport",
              },
              {
                text: "Risk Management Assistance",
                to: "/overview#RiskManagementAssistance",
              },
              {
                text: "Banking Relationship Advocacy",
                to: "/overview#BankingRelationshipAdvocacy",
              },
              {
                text: (
                  <>
                    Technological <br /> Support
                  </>
                ),
                to: "overview#TechnologicalSupport",
              },
              {
                text: "Advocacy and Representation",
                to: "/overview#AdvocacyandRepresentation",
              },
            ].map((benefit, index) => (
              <motion.div
                className="col-lg-4 mt-3"
                key={index}
                variants={itemVariants}
              >
                <div
                  className="funfact_block style_2"
                  style={{ background: "#efefef" }}
                >
                  <div className="funfact_value">
                    <NavLink to={benefit.to}>
                      <h3>{benefit.text}</h3>
                    </NavLink>
                  </div>
                </div>
              </motion.div>
            ))}

            {/* Learn More Button */}
            <motion.div
              className="col-lg-12 mt-5"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              variants={itemVariants}
            >
              <NavLink
                className="btn bg-primary text-dark"
                to="/overview#overview"
              >
                <span className="btn_label">Learn More</span>
              </NavLink>
            </motion.div>
            <div className="decoration_item shape_circle_image">
              <img
                src="assets/images/shapes/shape_circle_3.svg"
                alt="Circle Image"
              />
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default MsbBenefits;
